// 菜单 侧边栏
export default [
  // { path: '/index', title: '首页', icon: 'home'},
  // { path: '/workbench', children: [
  //         { path: '/workbench/index', title: '工作台' ,icon:'home'},
  //     ]
  // }
]
